import { render } from "./CategoryDetail.vue?vue&type=template&id=fca34920&ts=true&lang=pug"
import script from "./CategoryDetail.vue?vue&type=script&lang=ts"
export * from "./CategoryDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__